<template>
  <Transition name="fade">
    <div v-if="store.errorAlert.isVisible" class="fixed w-full max-w-md px-4 block error-position">
      <Alert :tone="'critical'" :dismissable="true" :onClose="hideAlert" class="shadow-lg">
        {{ errorMessage }}
      </Alert>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed, watch, onUnmounted } from "vue";
import { Alert } from "prism";
import { useEditorStore } from "@/stores/editor_store";

const store = useEditorStore();

const HIDE_ALERT_DELAY = 5000;

let hideTimer: NodeJS.Timeout | null = null;

const errorMessage = computed(() => {
  return store.errorAlert.message;
});

const hideAlert = () => {
  store.hideErrorAlert();
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
};

watch(
  () => store.errorAlert.isVisible,
  (isVisible) => {
    if (isVisible) {
      // Clear any existing timer
      if (hideTimer) {
        clearTimeout(hideTimer);
      }

      // Hide after 5 seconds
      hideTimer = setTimeout(hideAlert, HIDE_ALERT_DELAY);
    }
  },
  { immediate: true }
);

onUnmounted(() => {
  if (hideTimer) {
    clearTimeout(hideTimer);
  }
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translate(-50%, -10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -10px);
}

.error-position {
  z-index: 1000;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>
